import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";

const API = process.env.REACT_APP_API_URL;


function StudentProfile() {

    const { admNo } = useParams();

    const [student, setStudent] = useState(null);
    const [payments, setPayments] = useState([]);
    const [summary, setSummary] = useState(null);

    useEffect(() => {

        api.get(`/student-profile/${admNo}`)

            .then(res => {
                setStudent(res.data.student);
                setPayments(res.data.payments);
                setSummary(res.data.summary);
            })
            .catch(err => console.log(err));
    }, [admNo]);

    if (!student) return <div style={{ padding: 20 }}>Loading...</div>;

    return (
        <div style={container}>

            <h2 style={{ marginBottom: "20px" }}>Student Profile</h2>

            {/* 🧑 STUDENT DETAILS */}
            <div style={card}>
                <p><b>Admission No:</b> {student.admno}</p>
                <p><b>Name:</b> {student.name}</p>
                <p><b>Father Name:</b> {student.fathername}</p>
                <p><b>Class:</b> {student.class_name} - {student.section}</p>
                <p><b>Phone:</b> {student.phone}</p>
                <p><b>Route:</b> {student.routeno}</p>
            </div>


            <div style={{ marginBottom: "10px", fontWeight: "500" }}>
                Months Count: <span style={{ color: "#2563eb" }}>{summary?.months}</span>
            </div>


            {/* 💰 SUMMARY BOX */}
            <div style={summaryRow}>

                {/* Total Expected */}
                <div style={summaryCard("#2563eb")}>
                    <h4>Total Expected</h4>
                    ₹{summary?.totalExpected || 0}
                </div>

                {/* Total Paid */}
                <div style={summaryCard("#16a34a")}>
                    <h4>Total Paid</h4>
                    ₹{summary?.totalPaid || 0}
                </div>

                {/* Total Concession */}
                <div style={summaryCard("#f59e0b")}>
                    <h4>Total Concession</h4>
                    ₹{summary?.totalConcession || 0}
                </div>

                {/* Due (renamed Balance) */}
                <div style={summaryCard("#dc2626")}>
                    <h4>Due</h4>
                    ₹{summary?.balance || 0}
                </div>

            </div>

            {/* 📊 DUES BREAKDOWN */}
            {summary && (
                <div style={duesBox}>
                    <h3>Payment Breakdown</h3>

                    <table style={table}>
                        <thead>
                            <tr>
                                <th style={th}>Tuition<br />E / C / P / D</th>
                                <th style={th}>Conveyance<br />E / C / P / D</th>
                                <th style={th}>Exam<br />E / C / P / D</th>
                                <th style={th}>Admission<br />E / C / P / D</th>
                                <th style={th}>Total Due</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>

                                {/* Tuition */}
                                <td style={td}>
                                    ₹{summary.tuitionExpected}<br />
                                    <span style={{ color: "orange" }}>₹{summary.concessionTuition}</span><br />
                                    <span style={{ color: "green" }}>₹{summary.paidTuition}</span><br />
                                    <span style={{ color: summary.tuitionDue > 0 ? "red" : "green" }}>
                                        ₹{summary.tuitionDue}
                                    </span>
                                </td>

                                {/* Conveyance */}
                                <td style={td}>
                                    ₹{summary.conveyanceExpected}<br />
                                    <span style={{ color: "orange" }}>₹{summary.concessionTransport}</span><br />
                                    <span style={{ color: "green" }}>₹{summary.paidTransport}</span><br />
                                    <span style={{ color: summary.conveyanceDue > 0 ? "red" : "green" }}>
                                        ₹{summary.conveyanceDue}
                                    </span>
                                </td>

                                {/* Exam */}
                                <td style={td}>
                                    ₹{summary.examExpected}<br />
                                    <span style={{ color: "orange" }}>₹{summary.concessionExam}</span><br />
                                    <span style={{ color: "green" }}>₹{summary.paidExam}</span><br />
                                    <span style={{ color: summary.examDue > 0 ? "red" : "green" }}>
                                        ₹{summary.examDue}
                                    </span>
                                </td>

                                {/* Admission */}
                                <td style={td}>
                                    ₹{summary.admissionExpected}<br />
                                    <span style={{ color: "orange" }}>₹{summary.concessionAdmission}</span><br />
                                    <span style={{ color: "green" }}>₹{summary.paidAdmission}</span><br />
                                    <span style={{ color: summary.admissionDue > 0 ? "red" : "green" }}>
                                        ₹{summary.admissionDue}
                                    </span>
                                </td>



                                {/* Total Due */}
                                <td style={{ ...td, color: summary.balance > 0 ? "red" : "green", fontWeight: "bold" }}>
                                    ₹{summary.balance}
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            )}


            {/* 📜 PAYMENT HISTORY */}
            <h3 style={{ marginTop: "30px" }}>Payment History</h3>

            <table style={table}>
                <thead>
                    <tr>
                        <th style={th}>Receipt</th>
                        <th style={th}>Type</th>
                        <th style={th}>Month</th>
                        <th style={th}>Amount</th>
                        <th style={th}>Paid</th>
                        <th style={th}>Date</th>
                    </tr>
                </thead>

                <tbody>
                    {payments.map(p => (
                        <tr key={p.ReceiptNo}>
                            <td style={td}>{p.receiptno}</td>
                            <td style={td}>{p.feetype}</td>
                            <td style={td}>{p.month}</td>
                            <td style={td}>{p.amount}</td>
                            <td style={td}>{p.amountpaid}</td>
                            <td style={td}>{new Date(p.date).toLocaleDateString("en-IN")}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

/* 🎨 STYLES */

const container = {
    padding: "30px",
    maxWidth: "900px",
    margin: "auto"
};

const card = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    marginBottom: "20px"
};

const summaryRow = {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
    flexWrap: "wrap"
};

const summaryCard = (color) => ({
    flex: 1,
    padding: "20px",
    borderRadius: "10px",
    background: "#fff",
    borderTop: `5px solid ${color}`,
    textAlign: "center",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
});

const duesBox = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
};

const grid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: "10px"
};

const table = {
    width: "100%",
    borderCollapse: "collapse",
    background: "#fff",
    marginTop: "10px"
};

const th = {
    border: "1px solid #ddd",
    padding: "10px",
    background: "#f5f5f5"
};

const td = {
    border: "1px solid #ddd",
    padding: "10px"
};

const paymentBox = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    marginTop: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
};

export default StudentProfile;